import React from 'react';
import { Modal } from '@app/src/common/Modal';
import {
  ModalBody,
  ButtonActive,
  LoaderWrapper,
  ErrorMessage
} from './styled';
import { COLORS } from '@app/src/ui';
import { Icon } from '@app/src/common/Icon';
import { useDispatch, useSelector } from 'react-redux';
import { fetchAccountActive } from '@app/src/common/session';

interface Props {
  showModal?: boolean;
  closeModal?: Function;
}

export const ModalAccountActivationLogin: React.FC<Props> = ({
  showModal,
  closeModal
}) => {
  const dispatch = useDispatch();
  const isErrorPOST = useSelector(state => state.session.autentication.errorPOST);
  const messagePOST = useSelector(state => state.session.autentication.dataPOST.message);
  const isLoadingSendData = useSelector(state => state.session.autentication.isFetchingPOST);
  const currentEmail = useSelector(state => state.form.login.values.email);

  const handleClickReactive = () => {
    dispatch(fetchAccountActive({ email: currentEmail }));
  };

  return (
    <Modal show={showModal} closeModal={closeModal}>
      <ModalBody>
        {
          (isLoadingSendData) ?
            <LoaderWrapper>
              <Icon data-name='icon-circle' fill='#ccc' width={'17'} height={'17'} />
            </LoaderWrapper>
            :
            <React.Fragment>
              {
                (!isErrorPOST && messagePOST) ?
                  <React.Fragment>
                    <p>Se ha generado un nuevo código de activación. Revise su correo.</p>
                  </React.Fragment>
                  :
                  <React.Fragment>
                    <p>Tu cuenta no ha sido activada</p>
                    <ButtonActive
                      handleClick={handleClickReactive}
                      color="#fff"
                      background={COLORS.BLACK}
                      width={280}
                    >Generar código de Activación</ButtonActive>
                    {isErrorPOST && <ErrorMessage>Algo salió mal... inténtelo nuevamente</ErrorMessage>}
                  </React.Fragment>
              }
            </React.Fragment>
        }
      </ModalBody>
    </Modal>
  )
};
